export default function Income() {
  const benefits = [
    {
      icon: 'ri-money-euro-circle-line',
      title: 'Sehr hohe Provisionen',
      color: 'from-green-500 to-emerald-600'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Echtzeit-Auszahlung direkt auf dein Konto',
      color: 'from-blue-500 to-cyan-600'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Skalierbares Einkommen – flexibel nach Zeit & Einsatz',
      color: 'from-purple-500 to-pink-600'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Möglichkeit zum Aufbau eines dauerhaften Einkommensstroms',
      color: 'from-orange-500 to-red-600'
    },
    {
      icon: 'ri-global-line',
      title: 'Arbeiten von überall – komplett online',
      color: 'from-indigo-500 to-blue-600'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 text-center">
            Lukrative Provisionen
          </h2>
          <p className="text-2xl text-gray-700 mb-16 text-center">
            direkt in Echtzeit ausgezahlt
          </p>

          <p className="text-xl text-gray-800 mb-12 text-center">
            Als Partner profitierst du von einem sehr attraktiven Vergütungsmodell:
          </p>

          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {benefits.map((benefit, index) => (
              <div 
                key={index}
                className="bg-white border-2 border-gray-200 hover:border-transparent p-6 rounded-2xl transition-all duration-300 hover:shadow-2xl group cursor-pointer"
              >
                <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${benefit.color} rounded-2xl mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${benefit.icon} text-3xl text-white`}></i>
                </div>
                <p className="text-lg font-semibold text-gray-800 leading-relaxed">
                  {benefit.title}
                </p>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-br from-gray-900 to-gray-800 text-white p-10 rounded-2xl mb-8">
            <p className="text-xl mb-6 text-center">
              Du entscheidest selbst, ob du:
            </p>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-white/10 p-6 rounded-xl text-center">
                <p className="text-2xl font-bold">ein Zusatzeinkommen</p>
              </div>
              <div className="bg-white/10 p-6 rounded-xl text-center">
                <p className="text-2xl font-bold">oder ein vollwertiges Haupteinkommen</p>
              </div>
            </div>
            <p className="text-xl mt-6 text-center">
              aufbauen möchtest.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
